
import { MapLocation } from '@/types/location';

// Future Heroes Gym Locations
export const futureHeroesGyms: MapLocation[] = [
  {
    id: 37001,
    name: "Future Heroes - Riyadh (Al Malqa)",
    type: "Gym",
    devices: 1,
    coordinates: [24.806187331033804, 46.611038177911716],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "14-25",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 37002,
    name: "Future Heroes - Riyadh (Al Rabee)",
    type: "Gym",
    devices: 3,
    coordinates: [24.805319135228736, 46.6605105079134],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "14-25",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
